import { render, staticRenderFns } from "./Vaccination.vue?vue&type=template&id=0fb07241"
import script from "./Vaccination.vue?vue&type=script&lang=js"
export * from "./Vaccination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports